export default "__VITE_ASSET__C1DHr54Z__";